<div  [formGroup]="formGroup" [class]="data.classStyle">
      <mat-checkbox [formControlName]="data.name"> {{data.label}}</mat-checkbox>
</div>
